import React, { useState } from "react";
import ReactAudioPlayer from 'react-audio-player';
import { Helmet } from "react-helmet-async";
import { MY_EPISODE_QUERY } from "../host/my-episode";
import { getEpisodeQuery, getEpisodeQueryVariables } from "../../__generated__/getEpisodeQuery";
import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { timeSince } from "../../util/utility";
import { useHistory, useLocation, useParams } from "react-router-dom";

export const Episode = () => {
    const history = useHistory();
    const client = useApolloClient();
    let { id } = useParams();
    const location = useLocation();
    const { data, loading } = useQuery<
        getEpisodeQuery,
        getEpisodeQueryVariables
    >(MY_EPISODE_QUERY, {
        variables: {
            input: {
                podcastId: Number(location.state.podcast.id),
                episodeId: Number(location.state.id),
            },
        },
    });


    return (
        <div className="pb-96 pt-32">
            <Helmet>
                <title>Episode | KUDOK</title>
            </Helmet>
            <div className="bg-gray-800 w-full py-10 flex bg-no-repeat bg-cover" style={{ backgroundImage: `url(${'/images/podcast.jpeg'})` }}>
                <div className="flex flex-col text-white p-5 bg-gradient-to-r from-black">
                    <div className="flex flex-row m-5">
                        <div className="flex flex-col">
                            <h3 className="text-5xl">{data?.getEpisode.episode.title}</h3>
                            <span className="py-2 text-xs border-gray-400">
                                {timeSince(data?.getEpisode.episode.createdAt)}
                            </span>
                        </div>
                    </div>
                    <div className="p-5">
                        {data?.getEpisode.episode.description}
                    </div>
                    <div className="flex flex-row m-5">
                        <ReactAudioPlayer
                            src={data?.getEpisode.episode?.episodeVideo}
                            autoPlay
                            controls
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};